import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export const store = new Vuex.Store({
	state: {
		menu: false,
		contracts: [],
		selectedContract: '',
		products: [],
		primaryProducts: [],
		secondaryProducts: [],
		currentContract: { primaryProduct: '', secondaryProduct: '' },
		guid: '',
		user: '',
		account: ''
	},

	mutations: {
		openMenu(state) {
			state.menu = true;
		},

		closeMenu(state) {
			state.menu = false;
		},

		setContracts(state, data) {

			if (data.length) {
				data.forEach(item => {
					try {
						item.id = item.AccountingPointGuid,
							item.ap = item.AccountingPointIdentification,
							item.street = item.Address.StreetName,
							item.house = item.Address.BuildingNumber,
							item.city = item.Address.CityName
					} catch (err) {
						console.log(err);
					}
				});

				if (state.selectedContract) {
					let selected = data.find(item => item.ap === state.selectedContract.AccountingPointIdentification)
					store.commit('setSelectedContract', selected);
				} else {
					store.commit('setSelectedContract', data[0]);
				}
			}

			state.contracts = data;
		},

		setGUID(state, data) {
			state.guid = data;
		},

		setUser(state, data) {
			state.user = data;
		},

		setAccount(state, data) {
			state.account = data;
		},

		setProducts(state, data) {
			state.products = data;
		},

		setPrimaryProducts(state, data) {
			state.primaryProducts = data;
		},

		setSecondaryProducts(state, data) {
			state.secondaryProducts = data;
		},

		setSelectedContract(state, data) {
			let contractToUpdate = Object.assign({}, data),
				options = {
					headers: new Headers({ 'tenant': localStorage.tenant })
				};

			contractToUpdate.secondaryProducts = [];


			contractToUpdate.Products.forEach(product => {
				let detailedProduct = Object.assign({}, product);

				fetch(localStorage.api_url + '/weborder/v1/product/' + product.ProductId, options).then(response => response.json()).then(res => {
					try {
						detailedProduct.description = res.products[0].description;
					} catch (err) {
						console.log(err);
					}

				}).catch(error => {
					console.log(error);
				});

				if (detailedProduct.PrimaryProduct) {
					if (data.Address) {
						detailedProduct.address = data.Address.StreetName + ' ' + data.Address.BuildingNumber + ', ' + data.Address.PostCode + ' ' + data.Address.CityName;
					} else {
						detailedProduct.address = '';
					}

					contractToUpdate.primaryProduct = detailedProduct;
				} else {
					contractToUpdate.secondaryProducts.push(detailedProduct);
				}
			});

			state.selectedContract = contractToUpdate;

			let primaryProduct = contractToUpdate.Products.find(item => item.PrimaryProduct === true),
				secondaryProduct = contractToUpdate.Products.find(item => item.PrimaryProduct === false);

			state.currentContract = { primaryProduct: primaryProduct || {}, secondaryProduct: secondaryProduct || {} };
		}
	},

	getters: {
		isMenu: state => {
			return state.menu;
		},

		getGuid: state => {
			return state.guid;
		},

		getUser: state => {
			return state.user;
		},

		getAccount: state => {
			return state.account;
		},

		getContracts: state => {
			return state.contracts;
		},

		getProducts: state => {
			return state.products;
		},

		getPrimaryProducts: state => {
			return state.primaryProducts;
		},

		getSecondaryProducts: state => {
			return state.secondaryProducts;
		},

		getCurrentContract: state => {
			return state.currentContract;
		},

		getSelectedContract: state => {
			return state.selectedContract;
		}
	}
});